import { useSeo, SEO_PAGES } from "@/hooks/use-seo";
import { getLoginUrl } from "@/lib/auth-redirect";
import { PENDING_INPUT_STORAGE_KEY } from "@/lib/pending-input";
import type { InputType } from "@/components/landing/landing-data";
import { LandingNav } from "@/components/landing/landing-nav";
import { HeroSection } from "@/components/landing/hero-section";
import { TrendingSection } from "@/components/landing/trending-section";
import { QuestionsSection } from "@/components/landing/questions-section";
import { JournalSection } from "@/components/landing/journal-section";
import { HowItWorksDemo } from "@/components/landing/how-it-works-demo";
import { ManifestoSection } from "@/components/landing/manifesto-section";
import { FaqSection } from "@/components/landing/faq-section";
import { FinalCtaSection } from "@/components/landing/final-cta-section";
import { LandingFooter } from "@/components/landing/landing-footer";
import "@/components/landing/landing.css";

export default function Landing() {
  useSeo(SEO_PAGES["/"]);
  const loginUrl = getLoginUrl();

  /** Carry what the visitor typed through sign-in so the first thing they see
   * after login is their own input, already in the box. */
  const goUnfold = (value: string, type: InputType) => {
    const trimmed = value.trim();
    if (!trimmed) return;
    try {
      window.sessionStorage.setItem(
        PENDING_INPUT_STORAGE_KEY,
        JSON.stringify({ value: trimmed, type }),
      );
    } catch {
      /* ignore */
    }
    window.location.href = loginUrl;
  };

  return (
    <div className="lp min-h-screen">
      <LandingNav loginUrl={loginUrl} />
      <main>
        <HeroSection onUnfold={goUnfold} />
        <TrendingSection loginUrl={loginUrl} />
        <QuestionsSection />
        <JournalSection />
        <HowItWorksDemo />
        <ManifestoSection />
        <FaqSection />
        <FinalCtaSection onUnfold={goUnfold} />
      </main>
      <LandingFooter />
    </div>
  );
}
